__turbopack_context__.v({
  "footer": "_06uZQW_footer",
  "social-plug": "_06uZQW_social-plug",
});
